import type {
  BillingInterval,
  CancellationReason,
  PlanSlug,
} from "../api/types";

/**
 * La pagina dove una quota esaurita si scioglie davvero.
 *
 * Esiste solo quando `isBillingEnabled()` è vero: dietro `BillingGuard`, che
 * altrimenti manda a `/404`. Chi ci porta l'utente deve controllare il flag
 * prima di offrire il viaggio.
 */
export const PLAN_SELECTION_PATH = "/profile/company/upgrade";

export const PLAN_SLUGS: readonly PlanSlug[] = [
  "free",
  "headhunter",
  "team",
  "enterprise",
] as const;

export const BILLING_INTERVALS: readonly BillingInterval[] = [
  "monthly",
  "yearly",
] as const;

export const CANCELLATION_REASONS: readonly CancellationReason[] = [
  "too_expensive",
  "missing_features",
  "switched_to_competitor",
  "not_using_enough",
  "temporary_pause",
  "bad_experience",
  "other",
] as const;
